module.exports = __webpack_public_path__ + "static/media/fengxian.8a841acd.png";